import { render, staticRenderFns } from "./PendingMemo.vue?vue&type=template&id=45b00a1f"
import script from "./PendingMemo.vue?vue&type=script&lang=js"
export * from "./PendingMemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports